import { CgSpinner } from 'react-icons/cg';

export default function Spinner() {
  return <CgSpinner className='animate-spin text-xl' />;
}
